import * as React from 'react';

export const IconLoading = (props: React.SVGProps<SVGSVGElement>) => (
	<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
		<g fill="currentColor" transform="matrix(0.80289041,0,0,0.80289041,-4.2191891,-4.1501407)">
			<path
				style={{ opacity: 0.2 }}
				d="m 20.201,5.169 c -8.254,0 -14.946,6.692 -14.946,14.946 0,8.255 6.692,14.946 14.946,14.946 8.254,0 14.946,-6.691 14.946,-14.946 C 35.146,11.861 28.455,5.169 20.201,5.169 Z m 0,26.58 c -6.425,0 -11.634,-5.208 -11.634,-11.634 0,-6.425 5.209,-11.634 11.634,-11.634 6.425,0 11.633,5.209 11.633,11.634 0,6.426 -5.208,11.634 -11.633,11.634 z"
			/>
			<path d="M 26.013,10.047 27.667,7.181 C 25.469,5.909 22.924,5.169 20.201,5.169 l 0,0 0,3.312 0,0 c 2.119,0 4.1,0.576 5.812,1.566 z" />
		</g>
	</svg>
);
